import { useOutletContext } from 'react-router-dom';
import { ChangeScreenContext } from 'types/outlet';

export const useChangeScreenContext = () => {
  return useOutletContext<ChangeScreenContext>();
};
